
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.7127 1.04255C12.3872 0.736669 10.3618 2.11315 9.53662 4.10139C8.71144 2.11315 6.68601 0.81314 4.3605 1.04255C1.95998 1.34844 0.0845746 3.41315 0.00955835 5.86023C-0.0654579 7.00729 0.309623 8.07789 0.834737 8.91907C1.5849 9.98966 6.83604 15.6485 8.78646 17.7132C9.16154 18.0956 9.83669 18.0956 10.2118 17.7132C12.1622 15.6485 17.4883 10.0661 18.1635 8.91907C18.7636 8.07789 19.0637 7.00729 18.9887 5.86023C18.9137 3.41315 17.0382 1.34844 14.7127 1.04255Z","fill":"#EB5757"}})])
          )
        }
      }
    